import React from 'react'
import {
  Create,
  Datagrid,
  DisabledInput,
  Edit,
  EditButton,
  Filter,
  SelectInput,
  List,
  SimpleForm,
  TextField, TextInput,
} from 'admin-on-rest'
import {requireValidation} from "./utils/validation";

const TranslationFilter = (props) => {
  return (
    <Filter {...props}>
      <TextInput label="Key" source="key" alwaysOn />
      {/*<SelectInput
        label="Type"
        source="type"
        alwaysOn
        choices={[{ id: 'adyen_error', name: 'Adyen Error' }, { id: 'general', name: 'General' }]}
      />*/}
    </Filter>
  )
}

export const TranslationList = (props) => (
  <List {...props} filters={<TranslationFilter />} perPage={40} sort={{ field: '_id', order: 'DESC' }}>
    <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
      <TextField label="Key" source="key" />
      <TextField label="Type" source="type" />
      <TextField label="En" source="values.en" />
      <EditButton />
    </Datagrid>
  </List>
)

export const TranslationEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <DisabledInput source="id" />
      <DisabledInput label="Key" source="key" />
      <DisabledInput label="Type" source="type" />
      <TextInput label="EN" source="values.en" validate={requireValidation} options={{ fullWidth: true }} />
      <TextInput label="DE" source="values.de" validate={requireValidation} options={{ fullWidth: true }} />
      <TextInput label="ES" source="values.es" validate={requireValidation} options={{ fullWidth: true }} />
      <TextInput label="PT" source="values.pt" validate={requireValidation} options={{ fullWidth: true }} />
    </SimpleForm>
  </Edit>
)

export const TranslationCreate = (props) => (
    <Create {...props}>
      <SimpleForm>
        <TextInput source="key" label="Key" validate={requireValidation} />
        <SelectInput
            label="Type"
            source="type"
            alwaysOn
            choices={[{ id: 'adyen_error', name: 'Adyen Error' }, { id: 'general', name: 'General' }]}
        />
        <TextInput label="EN" source="values.en" validate={requireValidation} options={{ fullWidth: true }} />
        <TextInput label="DE" source="values.de" validate={requireValidation} options={{ fullWidth: true }} />
        <TextInput label="ES" source="values.es" validate={requireValidation} options={{ fullWidth: true }} />
        <TextInput label="PT" source="values.pt" validate={requireValidation} options={{ fullWidth: true }} />
      </SimpleForm>
    </Create>
)



// WEBPACK FOOTER //
// ./src/translations.js